<script lang="ts" setup>
import { computed, onMounted, ref } from '#imports';

const fileToName = (file: string) => {
  const name = file.split('/').pop()?.replace('.story.vue', '');
  return name;
};

const stories = import.meta.glob('./**.story.vue');
const storyMenu = computed(() => {
  return Object.keys(stories).map((key) => {
    const name = fileToName(key);
    return {
      name,
      path: key,
    };
  });
});

// The current selected story component
const selectedStory = ref(null);
const currentComponent = ref(null);

// Function to load a story component
const loadStory = async (path) => {
  try {
    // Dynamic import the selected story
    const component = await stories[path]();
    currentComponent.value = component.default;
    selectedStory.value = path;
  } catch (error) {
    console.error('Failed to load component:', error);
  }
};

// Load the first story by default
onMounted(async () => {
  if (storyMenu.value.length > 0) {
    await loadStory(storyMenu.value[0].path);
  }
});
</script>

<template>
  <main>
    <h1>Design Playground</h1>
    <p>Mappr Team tools for exploring and experimenting with different components.</p>
    <article>
      <aside class="sidebar">
        <div
          v-for="story in storyMenu"
          :key="story.name"
          class="story-link"
          :class="{ active: selectedStory === story.path }"
          @click="loadStory(story.path)"
        >
          {{ story.name }}
        </div>
      </aside>

      <div class="content">
        <h2 v-if="currentComponent">{{ fileToName(currentComponent.__file) }}</h2>
        <div class="story-container">
          <component v-if="currentComponent" :is="currentComponent" />
        </div>
      </div>
    </article>
  </main>
</template>

<style scoped>
article {
  display: grid;
  grid-template-columns: 200px 1fr;
  padding-top: 1rem;
}

main {
  margin: 0 auto;
  width: 100%;
  max-width: 70rem;
  padding: 1rem 3rem;
}

.story-link {
  cursor: pointer;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}

.sidebar {
  padding-right: 1rem;
}

.story-link.active {
  background-color: #f0f0f0;
  border-radius: 4px;
}

.story-container {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 1rem;
  margin: 0 0 2rem;
}
h2 {
  margin: 0 0 1rem;
}
</style>
